module.exports = __webpack_public_path__ + "static/media/postAssessment2.9725a12a.png";